import React from "react";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";

const DOMAIN = "https://webenamhossain.site";
const NAME = "Enam Hossain";
const MAIN_KEYWORDS = [
  "Enam Hossain",
  "Full-Stack Developer Bangladesh",
  "MERN Stack Developer",
  "React JS Developer",
  "Next.js Developer Expert",
  "WordPress Developer Bangladesh",
  "Shopify Expert Developer",
  "Web Performance Specialist",
  "Frontend Engineer Freelance",
  "Remote Developer",
  "Portfolio Enam Hossain"
];

const Seo = ({
  title = "Enam Hossain | Full-Stack MERN & WordPress Developer",
  description = "Full-stack website developer specialized in MERN, Next.js, WordPress, and Shopify. I craft high-performance interfaces, design systems, and AI-ready workflows for scaling businesses.",
  path = "/",
  metaImage = "https://res.cloudinary.com/deyk2vhta/image/upload/v1763635018/Gemini_Generated_Image_wa8zdcwa8zdcwa8z_mnh0ur.png"
}) => {
  const canonicalUrl = `${DOMAIN}${path}`;

  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "Person",
      "name": NAME,
      "jobTitle": "Full-Stack Website Developer",
      "url": DOMAIN,
      "image": metaImage,
      "sameAs": [
        "https://github.com/Enamhossain",
        "https://www.linkedin.com/in/webenamhossain",
        "https://twitter.com/webenamhossain",
        "https://facebook.com/webenamhossain"
      ],
      "knowsAbout": [
        "React", "Next.js", "Node.js", "MongoDB", "Express.js", 
        "WordPress", "Shopify", "JavaScript", "TypeScript", 
        "Web Performance", "SEO", "Responsive Design"
      ],
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "BD",
        "addressLocality": "Dhaka"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": title,
      "url": DOMAIN,
      "description": description,
      "publisher": {
        "@type": "Person",
        "name": NAME
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": `${NAME} - Development Services`,
      "image": metaImage,
      "url": DOMAIN,
      "telephone": "", 
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Dhaka",
        "addressCountry": "BD"
      },
      "serviceType": [
        "Full-Stack Web Development",
        "MERN Stack Development",
        "WordPress Customization",
        "Shopify Development",
        "Performance Optimization"
      ],
      "priceRange": "$$"
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": DOMAIN
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Projects",
          "item": `${DOMAIN}#projects`
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "About",
          "item": `${DOMAIN}#about`
        }
      ]
    }
  ];

  return (
    <Helmet prioritizeSeoTags>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={MAIN_KEYWORDS.join(", ")} />
      <meta name="author" content={NAME} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Verification for Google Search Console & Others */}
      {/* <meta name="google-site-verification" content="ADD_YOUR_VERIFICATION_CODE_HERE" /> */}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Enam Hossain - Professional Portfolio" />
      <meta property="og:site_name" content="Enam Hossain Portfolio" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@webenamhossain" />
      <meta name="twitter:creator" content="@webenamhossain" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={metaImage} />

      {/* Favicons & Icons */}
      <link rel="apple-touch-icon" sizes="180x180" href="/logo192.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon.ico" />
      
      {/* Performance Hints */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://res.cloudinary.com" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  path: PropTypes.string,
  metaImage: PropTypes.string
};

export default Seo;


